"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import { Button, TypographyH4, TypographyText } from "@workspace/frontend-ui";
import type { FC } from "react";

const NoFunModeMessage: FC = () => {
  const { isLoggedIn, setFunMode, requestAuth, t } = useGamePageData();

  return (
    <div
      data-testid="no-fun-mode-message"
      className="absolute inset-0 flex flex-col items-center justify-center gap-2 rounded-lg bg-secondary/80 p-6 text-center backdrop-blur"
    >
      <TypographyH4 isBold>
        {t("game.nofunmode.title", "This game has no Fun mode")}
      </TypographyH4>
      {isLoggedIn ? (
        <>
          <TypographyText>
            {t("game.nofunmode.realdescription", "Switch to Real to play it.")}
          </TypographyText>
          <Button className="mt-2" onClick={() => setFunMode(false)}>
            {t("game.nofunmode.switchtoreal", "Switch to Real")}
          </Button>
        </>
      ) : (
        <>
          <TypographyText>
            {t(
              "game.nofunmode.signindescription",
              "Sign in to play it for real.",
            )}
          </TypographyText>
          <Button className="mt-2" onClick={() => requestAuth()}>
            {t("game.nofunmode.signin", "Sign in")}
          </Button>
        </>
      )}
    </div>
  );
};

export default NoFunModeMessage;
